export default __webpack_public_path__ + "static/media/rocket_anim_91.3f038ee4.png";